"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Builder = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _settings = require("./settings.js");
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _optionTypes = _interopRequireDefault(require("./optionTypes"));
var _cccisdWysiwyg = _interopRequireDefault(require("cccisd-wysiwyg"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));
var _helpers = require("./helpers.js");
var _style = _interopRequireDefault(require("./style.css"));
var _classnames2 = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Builder = exports.Builder = /*#__PURE__*/function (_React$Component) {
  _inherits(Builder, _React$Component);
  function Builder() {
    var _this;
    _classCallCheck(this, Builder);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Builder, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_renderOption", function (option, optionField) {
      var element = _optionTypes["default"][option.type.value];
      var defaultValue = element.defaultLabel || element.name;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: option.label,
        label: "Label",
        isWysiwyg: true,
        wysiwygProps: {
          autofocus: 'end',
          selectAllOnFocus: option.label.value === defaultValue
        }
      }), optionField);
    });
    _defineProperty(_assertThisInitialized(_this), "_renderSingleAnswerRequired", function () {
      var _this$props$fields = _this.props.fields,
        singleAnswerRequired = _this$props$fields.singleAnswerRequired,
        isRequiredExpanded = _this$props$fields.isRequiredExpanded,
        isValidationExpanded = _this$props$fields.isValidationExpanded,
        requiredErrorMessage = _this$props$fields.requiredErrorMessage,
        visualType = _this$props$fields.visualType,
        singleOrMultiple = _this$props$fields.singleOrMultiple;
      var showIsRequired = visualType.value === 'radio' || visualType.value === 'dropdown' || visualType.value === 'image' && singleOrMultiple.value === 'single' || visualType.value === 'button' && singleOrMultiple.value === 'single';
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Required",
        type: _this.props.formBlockType,
        show: isRequiredExpanded.value,
        handleClick: isRequiredExpanded.onChange
      }, showIsRequired ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: _objectSpread({
          marginTop: 0
        }, !singleAnswerRequired.value && {
          marginBottom: 0
        })
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(singleAnswerRequired))), " Require an answer")), singleAnswerRequired.value && /*#__PURE__*/_react["default"].createElement("div", {
        className: _cccisdSurveyCommon.commonStyle.lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: requiredErrorMessage,
        label: "Required error message"
      }))) : 'See Validation for requirements'), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Validation",
        type: _this.props.formBlockType,
        show: isValidationExpanded.value,
        handleClick: isValidationExpanded.onChange
      }, showIsRequired ? 'Not applicable for this question format type' : _this._renderMinMaxAnswers()));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderAnswerFeedbackBlock", function () {
      var _this$props$fields2 = _this.props.fields,
        showAnswerFeedbackExpanded = _this$props$fields2.showAnswerFeedbackExpanded,
        showAnswerFeedback = _this$props$fields2.showAnswerFeedback,
        answerFeedbackForOptions = _this$props$fields2.answerFeedbackForOptions,
        answerFeedbackPositive = _this$props$fields2.answerFeedbackPositive,
        answerFeedbackNegative = _this$props$fields2.answerFeedbackNegative,
        options = _this$props$fields2.options,
        hasCorrectAnswers = _this$props$fields2.hasCorrectAnswers,
        correctAnswers = _this$props$fields2.correctAnswers,
        visualType = _this$props$fields2.visualType,
        singleOrMultiple = _this$props$fields2.singleOrMultiple;
      var onFeedbackForOptionsChange = function onFeedbackForOptionsChange(id, value) {
        answerFeedbackForOptions.onChange(_objectSpread(_objectSpread({}, answerFeedbackForOptions.value), {}, _defineProperty({}, id, value)));
      };
      var isMultiple = visualType.value === 'checkbox' || visualType.value === 'image' && singleOrMultiple.value === 'multiple' || visualType.value === 'button' && singleOrMultiple.value === 'multiple';
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Answer feedback",
        type: _this.props.formBlockType,
        show: showAnswerFeedbackExpanded.value,
        handleClick: showAnswerFeedbackExpanded.onChange
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: _objectSpread({
          marginTop: '0'
        }, !showAnswerFeedback.value && {
          marginBottom: '0'
        })
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(showAnswerFeedback), {
        checked: !!showAnswerFeedback.value
      })), ' ', "Show answer feedback to respondent")), showAnswerFeedback.value && (isMultiple && hasCorrectAnswers.value ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].right
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: answerFeedbackPositive,
        label: "Positive feedback"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
        content: answerFeedbackPositive.value,
        onChange: answerFeedbackPositive.onChange
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].wrong + ' ' + _cccisdSurveyCommon.commonStyle.lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: answerFeedbackNegative,
        label: "Negative feedback"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
        content: answerFeedbackNegative.value,
        onChange: answerFeedbackNegative.onChange
      })))) : /*#__PURE__*/_react["default"].createElement("div", {
        className: _cccisdSurveyCommon.commonStyle.lastRow
      }, options.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: option.id.value,
          className: (0, _classnames2["default"])('form-group', _defineProperty(_defineProperty({}, _style["default"].right, hasCorrectAnswers.value && correctAnswers.value.includes(option.id.value)), _style["default"].wrong, hasCorrectAnswers.value && !correctAnswers.value.includes(option.id.value)))
        }, /*#__PURE__*/_react["default"].createElement("label", {
          className: "control-label"
        }, (0, _cccisdSurveyCommon.stripTags)(option.label.value)), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
          content: (0, _get2["default"])(answerFeedbackForOptions.value, option.id.value, ''),
          onChange: onFeedbackForOptionsChange.bind(null, option.id.value)
        }));
      }))));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderMinMaxAnswers", function () {
      var _this$props$fields3 = _this.props.fields,
        multiAnswerMin = _this$props$fields3.multiAnswerMin,
        multiAnswerMax = _this$props$fields3.multiAnswerMax,
        minAnswersErrorMessage = _this$props$fields3.minAnswersErrorMessage,
        maxAnswersErrorMessage = _this$props$fields3.maxAnswersErrorMessage;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: multiAnswerMin,
        label: "Min answers"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: multiAnswerMax,
        label: "Max answers"
      }))), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: minAnswersErrorMessage,
        label: "Error message when less than min answers"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _cccisdSurveyCommon.commonStyle.lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: maxAnswersErrorMessage,
        label: "Error message when more than max answers"
      })));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderDropdownZeroLabel", function () {
      var dropdownZeroLabel = _this.props.fields.dropdownZeroLabel;
      return /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: dropdownZeroLabel,
        label: "Label"
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_renderDropdownWidth", function () {
      var dropdownWidth = _this.props.fields.dropdownWidth;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: dropdownWidth,
        label: "Width",
        comment: "e.g. auto or 200px"
      })));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderWidthAndMinHeight", function () {
      var _this$props$fields4 = _this.props.fields,
        minButtonHeight = _this$props$fields4.minButtonHeight,
        buttonTextAlign = _this$props$fields4.buttonTextAlign;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.TextBlock, {
        field: minButtonHeight,
        label: "Height"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-6"
      }, _this._renderVerticalWidth())), /*#__PURE__*/_react["default"].createElement("div", {
        className: _cccisdSurveyCommon.commonStyle.lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: buttonTextAlign,
        label: "Button text alignment"
      }, /*#__PURE__*/_react["default"].createElement("select", _extends({}, (0, _domOnlyProps["default"])(buttonTextAlign), {
        className: "form-control",
        style: {
          width: 'auto'
        }
      }), /*#__PURE__*/_react["default"].createElement("option", {
        value: "center"
      }, "Center"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "flex-start"
      }, "Left"), /*#__PURE__*/_react["default"].createElement("option", {
        value: "flex-end"
      }, "Right")))));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderSingleOrMultiple", function () {
      var singleOrMultiple = _this.props.fields.singleOrMultiple;
      return /*#__PURE__*/_react["default"].createElement(_helpers.RadioInline, {
        field: singleOrMultiple,
        label: "Single or multiple",
        options: [{
          label: 'Single',
          value: 'single'
        }, {
          label: 'Multiple',
          value: 'multiple'
        }]
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_renderImageSize", function () {
      var imageSize = _this.props.fields.imageSize;
      return /*#__PURE__*/_react["default"].createElement(_helpers.RadioInline, {
        field: imageSize,
        label: "Image size",
        options: [{
          label: 'Small',
          value: 'small'
        }, {
          label: 'Medium',
          value: 'medium'
        }, {
          label: 'Large',
          value: 'large'
        }]
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_renderImagePadding", function () {
      var imagePadding = _this.props.fields.imagePadding;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox"
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(imagePadding))), " Add padding around image"));
    });
    _defineProperty(_assertThisInitialized(_this), "_renderVerticalOrHorizontal", function () {
      var verticalOrHorizontal = _this.props.fields.verticalOrHorizontal;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_helpers.RadioInline, {
        field: verticalOrHorizontal,
        label: "Choice layout",
        options: [{
          label: 'Vertical',
          value: 'vertical'
        }, {
          label: 'Horizontal',
          value: 'horizontal'
        }]
      }), verticalOrHorizontal.value === 'vertical' && _this._renderVerticalWidth());
    });
    _defineProperty(_assertThisInitialized(_this), "_renderVerticalWidth", function () {
      var verticalWidth = _this.props.fields.verticalWidth;
      return /*#__PURE__*/_react["default"].createElement(_helpers.RadioInline, {
        field: verticalWidth,
        label: "Width",
        options: [{
          label: 'Small',
          value: 'small'
        }, {
          label: 'Medium',
          value: 'medium'
        }, {
          label: 'Large',
          value: 'large'
        }]
      });
    });
    return _this;
  }
  _createClass(Builder, [{
    key: "render",
    value: function render() {
      var _this$props$fields5 = this.props.fields,
        question = _this$props$fields5.question,
        isOptionsExpanded = _this$props$fields5.isOptionsExpanded,
        options = _this$props$fields5.options,
        optionTypes = _this$props$fields5.optionTypes,
        isRadioDropdownExpanded = _this$props$fields5.isRadioDropdownExpanded,
        visualType = _this$props$fields5.visualType,
        showLabelsInMatrixHeader = _this$props$fields5.showLabelsInMatrixHeader,
        description = _this$props$fields5.description,
        correctAnswers = _this$props$fields5.correctAnswers,
        hasCorrectAnswers = _this$props$fields5.hasCorrectAnswers,
        showCorrectnessFeedback = _this$props$fields5.showCorrectnessFeedback;
      var DataConnectorsPicker = this.props.DataConnectorsPicker;

      // Don't allow list options in matrix mode
      var elementTypes = this.props.isMatrixMode ? (0, _omit2["default"])(_optionTypes["default"], ['list']) : _optionTypes["default"];
      return /*#__PURE__*/_react["default"].createElement("div", null, !this.props.isMatrixMode && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: question,
        label: "Question"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
        content: question.value,
        type: "textarea-inline",
        onChange: question.onChange,
        selectAllOnFocus: question.value === _settings.initialValues.question
      })), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: description,
        label: "Description"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg["default"], {
        content: description.value,
        type: "textarea-inline",
        onChange: description.onChange
      }))), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: /*#__PURE__*/_react["default"].createElement("span", null, "Choices ", /*#__PURE__*/_react["default"].createElement("span", {
          className: "badge"
        }, options.length)),
        type: this.props.formBlockType,
        show: isOptionsExpanded.value,
        handleClick: function handleClick(show) {
          return isOptionsExpanded.onChange(show);
        },
        isError: (0, _cccisdSurveyCommon.checkForErrors)([options, optionTypes])
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.DragDropElements, {
        constant: this.props.optionsConstant,
        elements: options,
        elementTypes: elementTypes,
        elementFields: optionTypes,
        renderElement: this._renderOption,
        dragHint: "Drag choices here",
        blockType: "success",
        moveOnTab: true,
        extraProps: {
          settings: this.props.values,
          DataConnectorsPicker: DataConnectorsPicker,
          isMatrixMode: this.props.isMatrixMode
        }
      }), !this.props.isMatrixMode && /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          marginBottom: 0
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(hasCorrectAnswers), {
        onChange: function onChange(e) {
          hasCorrectAnswers.onChange(e);
          // change showCorrectnessFeedback as well
          showCorrectnessFeedback.onChange(false);
        }
      })), ' ', "The question has correct answer(s)")), !this.props.isMatrixMode && hasCorrectAnswers.value && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          marginTop: 0
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(showCorrectnessFeedback))), " Show which choices were correct/incorrect when checking answers")), /*#__PURE__*/_react["default"].createElement("div", {
        className: _cccisdSurveyCommon.commonStyle.lastRow
      }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: correctAnswers,
        label: "Correct answers"
      }, options.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: option.id.value,
          className: "checkbox",
          style: {
            margin: 0
          }
        }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
          type: "checkbox",
          onChange: function onChange() {
            return correctAnswers.onChange((0, _xor2["default"])(correctAnswers.value, [option.id.value]));
          },
          checked: correctAnswers.value.includes(option.id.value)
        }), ' ', (0, _cccisdSurveyCommon.stripTags)(option.label.value)));
      }))))), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FormBlock, {
        title: "Formatting",
        type: this.props.formBlockType,
        show: isRadioDropdownExpanded.value,
        handleClick: function handleClick(show) {
          return isRadioDropdownExpanded.onChange(show);
        }
      }, /*#__PURE__*/_react["default"].createElement(_helpers.RadioInline, {
        field: visualType,
        label: "Type",
        options: [{
          label: 'Radio',
          value: 'radio'
        }, {
          label: 'Checkbox',
          value: 'checkbox'
        }, {
          label: 'Image',
          value: 'image'
        }, {
          label: 'Button',
          value: 'button'
        }, {
          label: 'Dropdown',
          value: 'dropdown'
        }]
      }), visualType.value === 'radio' && /*#__PURE__*/_react["default"].createElement("div", null, this.props.isMatrixMode && /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: showLabelsInMatrixHeader.value ? {
          marginBottom: '0'
        } : {}
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(showLabelsInMatrixHeader))), " Show choice labels in column header")), (!this.props.isMatrixMode || !showLabelsInMatrixHeader.value) && /*#__PURE__*/_react["default"].createElement("div", {
        className: _cccisdSurveyCommon.commonStyle.lastRow
      }, this._renderVerticalOrHorizontal())), visualType.value === 'checkbox' && /*#__PURE__*/_react["default"].createElement("div", null, this.props.isMatrixMode && /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: showLabelsInMatrixHeader.value ? {
          marginBottom: '0'
        } : {}
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox"
      }, (0, _domOnlyProps["default"])(showLabelsInMatrixHeader))), " Show choice labels in column header")), (!this.props.isMatrixMode || !showLabelsInMatrixHeader.value) && /*#__PURE__*/_react["default"].createElement("div", {
        className: _cccisdSurveyCommon.commonStyle.lastRow
      }, this._renderVerticalOrHorizontal())), visualType.value === 'image' && /*#__PURE__*/_react["default"].createElement("div", {
        className: _cccisdSurveyCommon.commonStyle.lastRow
      }, this._renderSingleOrMultiple(), this._renderImageSize(), this._renderImagePadding()), visualType.value === 'button' && /*#__PURE__*/_react["default"].createElement("div", null, this._renderSingleOrMultiple(), this._renderWidthAndMinHeight()), visualType.value === 'dropdown' && /*#__PURE__*/_react["default"].createElement("div", {
        className: _cccisdSurveyCommon.commonStyle.lastRow
      }, this._renderDropdownZeroLabel(), this._renderDropdownWidth())), this._renderSingleAnswerRequired(), !this.props.isMatrixMode && this._renderAnswerFeedbackBlock());
    }
  }]);
  return Builder;
}(_react["default"].Component);
_defineProperty(Builder, "propTypes", {
  fields: _propTypes["default"].object,
  formBlockType: _propTypes["default"].string,
  optionsConstant: _propTypes["default"].string,
  isMatrixMode: _propTypes["default"].bool,
  values: _propTypes["default"].object
});
_defineProperty(Builder, "defaultProps", {
  formBlockType: 'primary',
  optionsConstant: 'OPTION',
  isMatrixMode: false
});
var _default = exports["default"] = (0, _cccisdSurveyCommon.builderWrapper)({
  fields: _settings.fields,
  validate: _settings.validate,
  initialValues: _settings.initialValues,
  withTemplate: true,
  withAccommodations: true,
  withVisibilityConditions: true,
  withQuestionNumbers: true,
  withAdjustedPlayerSettings: true,
  withBubbleMessages: true,
  withDefaultValueFromVariable: true
})(Builder);